import {
  singleSelectedCategorySchema,
  multiSelectedCategory,
} from 'validations/common/selected-category';

export const singleStoreTypeSchema = singleSelectedCategorySchema;

export const multiStoreTypeSchema = multiSelectedCategory;
